import { YStack } from '@/components/ui/layout/layout';

export function MeetingDebugSection({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <YStack
      role="region"
      aria-label={title}
      className="rounded-lg border border-border bg-surface px-3 py-2 gap-1.5"
    >
      <h2 className="text-xs font-semibold text-foreground uppercase tracking-wide">
        {title}
      </h2>
      {children}
    </YStack>
  );
}
